export const BANCOS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/bancos';
export const REGIONES_ENDPOINT = process.env.REACT_APP_BASE_URL + '/regiones';
export const MONEDAS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/portabilidad/monedas';
export const FAMILIAS_PRODUCTOS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/familiasProductos';
export const PRODUCTOS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/productos';
export const INIT_ENDPOINT = process.env.REACT_APP_BASE_URL + '/portabilidad/ingresar';
export const PREGUNTAS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente/autenticacion/preguntas';
export const BUSCAR_CLIENTE_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente/buscar';
export const CLIENTE_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente';
export const RESPUESTAS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente/autenticacion/respuestas';
export const OFERTAS_ENDPOINT = process.env.REACT_APP_BASE_URL + '/portabilidad/ofertas';

export const GENERAR_CERTIFICADO_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente/solicitud/certificado';
export const SOLICITUD_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente/solicitud';

export const SOLICITUDES_CLIENTE_ENDPOINT = process.env.REACT_APP_BASE_URL + '/cliente/solicitud';

export const GET_PUBLICKEY_ENCRYPTION = process.env.REACT_APP_BASE_URL + '/portabilidad-key-generator';
